import { Component, OnInit } from '@angular/core';

import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { config } from 'app/constants';
import { HelperService, HTTPService, DataService, FormatService } from 'app/services';
import { datetimeFormat } from 'app/constants/date-time-format';
import { DateService } from 'app/services/date.service';

@Component({
  selector: 'app-edit-technician-attendence-dialogue',
  templateUrl: './edit-technician-attendence-dialogue.component.html',
  styleUrls: ['./edit-technician-attendence-dialogue.component.scss'],
})
export class EditTechnicianAttendenceDialogueComponent implements OnInit {
  activities: any = [];
  clockActivities: any = [];
  payload: any = [];
  techRecords: any = [];
  statsQuery = {
    startDate: null,
    endDate: null,
    techId: null,
  };
  listQuery = {
    startDate: null,
    endDate: null,
    techId: null,
    sortField: 'start',
    sortOrder: 1,
  };
  isLoading: boolean = false;
  isDeleted: boolean = false;
  isFetchingDetails: boolean = false;

  isCurrentEditStartTime: boolean = false;
  isCurrentEditEndTime: boolean = false;

  currentDateTime: any;

  isCurrentBeforeStart: boolean = false;
  isCurrentBeforeEndTime: boolean = false;

  isCurrentAfterStartTime: boolean = false;
  isCurrentAftereEnd: boolean = false;

  isBeforeEdit: boolean = false;
  isOverlapBefore: boolean = false;
  isOverlapAfter: boolean = false;
  isOverlapAfterStartTime: boolean = false;
  isInvalidAfterStartTime: boolean = false;
  isInvalidEditEndTime: boolean = false;
  isInvalidEditStartTime: boolean = false;

  isValidClockStartTime: boolean = false;
  isValidClockEndTime: boolean = false;

  startTimeOverLap: boolean = false;
  endTimeOverLap: boolean = false;
  clockInDetected: boolean = false;

  serviceStartTimeOverlap: boolean = false;
  serviceEndTimeOverlap: boolean = false;

  isOverlapBeforeStartTime: boolean = false;
  isOverlapAfterEndtTime: boolean = false;

  isAfterEdit: boolean = false;
  isClockIn: boolean = false;
  techClockIn: boolean = false;
  isToday: boolean = false;
  endTimeValid: boolean = false;

  data: any = {};
  techId: string = '';
  techName: string = '';
  startDate: string = '';
  endDate: string = '';
  workType: string = '';

  before: any = [];
  edit: any = [];
  after: any = [];
  updateClockInOut: any = [];

  techStatuses: any = [
    {
      label: 'Completed',
      value: 'completed',
    },
    {
      label: 'Paused',
      value: 'pause',
    },
  ];

  editStartDate: any;
  editEndDate: any;

  beforeStartDate: any;
  beforeEndDate: any;

  afterStartDate: any;
  afterEndDate: any;
  updatedDate: any;

  updateClockStartDate: any;
  updateClockEndDate: any;

  constructor(
    public dConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private dateService: DateService,
    private httpService: HTTPService,
    public helperService: HelperService,
    private formatService: FormatService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.data = this.dConfig.data;
    this.techId = this.data.id;
    this.techName = this.data.techName;
    this.workType = this.data.workType;
    this.isClockIn = this.data.isClockIn;

    this.startDate = this.data.startDate;
    this.endDate = this.data.endDate;

    this.statsQuery.startDate = this.startDate;
    this.statsQuery.endDate = this.endDate;
    this.statsQuery.techId = this.techId;

    this.listQuery.startDate = this.startDate;
    this.listQuery.endDate = this.endDate;
    this.listQuery.techId = this.techId;

    this.getDetails();
    // this.getReportData();
    // this.getTechDetails();
  }

  async getDetails() {
    this.isFetchingDetails = true;

    try {
      await Promise.all([this.getReportData(), this.getTechDetails()]);
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isFetchingDetails = false;
    }
  }

  async getTechDetails() {
    this.currentDateTime = await this.httpService.getServerTime();
    this.currentDateTime = this.dateService.getCurrentDateTimeTz(this.currentDateTime);

    this.isToday = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date().getTime()), datetimeFormat.yyymmdd) === this.startDate ? true : false;
  }

  /**
   * Get Report Data
   */
  async getReportData() {
    try {
      let listData = await this.httpService.getAttendanceLogDetailsList(this.listQuery);

      if (!listData?.records?.length) {
        listData = {
          records: [],
          metaData: {
            totalRecords: 0,
            page: 0,
            limit: 0,
            skip: 0,
          },
        };
      }

      this.techRecords = this.formatService.formatTechAttendanceLogDetails(listData.records);

      this.before = this.techRecords[this.techRecords.findIndex((x) => x._id === this.data.logID) - 1];
      this.edit = this.techRecords[this.techRecords.findIndex((x) => x._id === this.data.logID)];
      this.after = this.techRecords[this.techRecords.findIndex((x) => x._id === this.data.logID) + 1];

      if (this.edit.action === 'inprogress') {
        this.techStatuses.push({
          label: 'Inprogress',
          value: 'inprogress',
        });
      }

      if (this.edit.action) {
        this.edit.action = this.edit.action === 'pause' || this.edit.action === 'Paused' ? this.techStatuses[1] : this.edit.action === 'inprogress' ? this.techStatuses[2] : this.techStatuses[0];
      }
      this.updateClockInOut = this.techRecords[this.techRecords.findIndex((x) => x._id === this.data.logID)];

      if (this.edit.history) {
        this.activities = this.edit.history;
        this.activities.forEach((activity: any) => {
          activity.createdAt = this.dateService.getCurrentDateTimeTz(new Date(activity.createdAt).getTime());
        });
      }

      if (this.updateClockInOut.history) {
        this.clockActivities = this.updateClockInOut.history;
      }

      listData.records.map((record) => {
        if (this.workType === 'clock') {
          if (record.start && record.order === 'Clocked-in' && record._id === this.data.logID) this.updateClockInOut.start = this.dateService.getCurrentDateTimeTz(new Date(record.start).getTime());
          if (record._id === this.data.logID) {
            if (record.end && record.order === 'Clocked-out') {
              this.endTimeValid = false;
              this.updateClockInOut.end = this.dateService.getCurrentDateTimeTz(new Date(record.end).getTime());
            } else {
              this.endTimeValid = true;
            }
          }
        }
      });

      this.setTime();
    } catch (error) {
      this.helperService.showToaster('error', error);
    }
  }

  // SET Before, Edit, After TIME Formate
  setTime() {
    this.updateClockStartDate = this.updateClockInOut.start
      ? new Date(
          this.updateClockInOut.start.getFullYear(),
          this.updateClockInOut.start.getMonth(),
          this.updateClockInOut.start.getDate(),
          this.updateClockInOut.start.getHours(),
          this.updateClockInOut.start.getMinutes()
        )
      : '';

    this.updateClockEndDate = this.updateClockInOut.end
      ? new Date(
          this.updateClockInOut.end.getFullYear(),
          this.updateClockInOut.end.getMonth(),
          this.updateClockInOut.end.getDate(),
          this.updateClockInOut.end.getHours(),
          this.updateClockInOut.end.getMinutes()
        )
      : '';

    this.editStartDate = this.edit.start
      ? new Date(this.edit.start.getFullYear(), this.edit.start.getMonth(), this.edit.start.getDate(), this.edit.start.getHours(), this.edit.start.getMinutes())
      : '';

    this.editEndDate = this.edit.end ? new Date(this.edit.end.getFullYear(), this.edit.end.getMonth(), this.edit.end.getDate(), this.edit.end.getHours(), this.edit.end.getMinutes()) : '';

    this.beforeStartDate = this.before
      ? this.before.start
      : ''
      ? new Date(this.before.start.getFullYear(), this.before.start.getMonth(), this.before.start.getDate(), this.before.start.getHours(), this.before.start.getMinutes())
      : '';

    this.beforeEndDate = this.before
      ? this.before.end
      : ''
      ? new Date(this.before.end.getFullYear(), this.before.end.getMonth(), this.before.end.getDate(), this.before.end.getHours(), this.before.end.getMinutes())
      : '';
    this.afterStartDate = this.after
      ? this.after.start
      : ''
      ? new Date(this.after.start.getFullYear(), this.after.start.getMonth(), this.after.start.getDate(), this.after.start.getHours(), this.after.start.getMinutes())
      : '';

    this.afterEndDate = this.after
      ? this.after.end
      : ''
      ? new Date(this.after.end.getFullYear(), this.after.end.getMonth(), this.after.end.getDate(), this.after.end.getHours(), this.after.end.getMinutes())
      : '';
    this.updatedDate = this.edit.updatedDate
      ? new Date(this.edit.updatedDate.getFullYear(), this.edit.updatedDate.getMonth(), this.edit.updatedDate.getDate(), this.edit.updatedDate.getHours(), this.edit.updatedDate.getMinutes())
      : '';
  }

  showBeforeTime() {
    if (this.isOverlapBefore) {
      this.isBeforeEdit = true;
    }
  }

  showAfterTime() {
    if (this.isOverlapAfter) {
      this.isAfterEdit = true;
    }
  }

  formateTime(date) {
    if (date) {
      return date !== '-' ? this.dateService.formatDate(date, datetimeFormat.hmma) : '-';
    }
  }

  formateTimeWithoutTimezone(date) {
    if (date) {
      return date !== '-' ? this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(date).getTime()), datetimeFormat.hmma) : '';
    }
  }

  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  onSelectEditServiceStatus(e) {
    this.edit.action = e;
  }

  async handleEditStartDate(type) {
    // this.currentDateTime = await this.httpService.getServerTime();
    this.currentDateTime = this.dateService.getCurrentDateTimeTz(this.currentDateTime);
    if (type === 'editStartDate') {
      if (this.edit.action.value === 'inprogress') {
        this.helperService.showToaster('error', 'Service is Inprogress');
        return;
      }
      // check end time with current timezone
      if (this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(this.currentDateTime).getTime()), datetimeFormat.yyymmdd) === this.startDate) {
        const startDate = new Date(this.currentDateTime.getFullYear(), this.currentDateTime.getMonth(), this.currentDateTime.getDate(), this.editStartDate.getHours(), this.editStartDate.getMinutes());

        if (startDate > this.currentDateTime) {
          this.isInvalidEditStartTime = true;
          return;
        }
      }

      this.isCurrentEditStartTime = this.editStartDate !== this.edit.start ? true : false;
      this.isOverlapBefore = this.beforeEndDate ? (this.editStartDate <= this.beforeEndDate ? true : false) : false;
      this.isOverlapBeforeStartTime = this.beforeStartDate ? (this.editStartDate < this.beforeStartDate ? true : false) : false;

      this.isInvalidEditStartTime = this.editEndDate < this.editStartDate ? true : false;
      this.isInvalidEditEndTime = this.editEndDate < this.editStartDate ? true : false;
    } else if (type === 'editEndDate') {
      // check end time with current timezone
      if (this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(this.currentDateTime).getTime()), datetimeFormat.yyymmdd) === this.startDate) {
        const endDate = new Date(this.currentDateTime.getFullYear(), this.currentDateTime.getMonth(), this.currentDateTime.getDate(), this.editEndDate.getHours(), this.editEndDate.getMinutes());
        if (endDate > this.currentDateTime) {
          this.isInvalidEditEndTime = true;
          return;
        }
      }

      if (this.edit.action.value === 'inprogress') {
        this.helperService.showToaster('error', 'Service is Inprogress');
        return;
      }
      this.isCurrentEditEndTime = this.editEndDate !== this.edit.end ? true : false;

      this.isInvalidEditStartTime = this.editEndDate < this.editStartDate ? true : false;
      this.isInvalidEditEndTime = this.editEndDate < this.editStartDate ? true : false;

      this.isOverlapAfter = this.afterStartDate ? (this.editEndDate >= this.afterStartDate ? true : false) : false;
      this.isOverlapAfterStartTime = this.afterStartDate < this.editEndDate ? true : false;
      this.isOverlapAfterEndtTime = this.afterEndDate ? (this.afterEndDate <= this.editEndDate ? true : false) : false;
    } else if (type === 'beforeEndDate') {
      this.isCurrentBeforeEndTime = this.editEndDate !== this.before.end ? true : false;

      this.isOverlapBeforeStartTime = this.editStartDate < this.beforeStartDate ? true : false;
      this.isOverlapBefore = this.editStartDate <= this.beforeEndDate ? true : false;
    } else if (type === 'afterStartDate') {
      this.isCurrentAfterStartTime = this.afterStartDate !== this.after.start ? true : false;
      this.isInvalidAfterStartTime = this.afterStartDate > this.afterEndDate ? true : false;

      this.isOverlapAfter = this.afterStartDate ? (this.editEndDate >= this.afterStartDate ? true : false) : false;

      this.isOverlapAfterStartTime = this.afterStartDate < this.editEndDate ? true : false;
      this.isOverlapAfterEndtTime = this.afterEndDate <= this.editEndDate ? true : false;
    }
  }

  onSubmit() {
    if (
      this.isOverlapBefore ||
      this.isOverlapAfter ||
      this.isOverlapAfterEndtTime ||
      this.isOverlapAfterEndtTime ||
      this.isOverlapBeforeStartTime ||
      this.isInvalidEditStartTime ||
      this.isInvalidEditEndTime ||
      this.isInvalidAfterStartTime
    ) {
      return false;
    } else {
      let finalPayload = [];
      let payload = [];

      if (this.before) {
        payload.push({
          action: this.before.action,
          end: this.beforeEndDate ? this.dateService.formatDate(this.beforeEndDate, datetimeFormat.yyymmddhhmm) : null,
          start: this.beforeStartDate ? this.dateService.formatDate(this.beforeStartDate, datetimeFormat.yyymmddhhmm) : null,
          workId: this.before.workId,
          orderId: this.before.orderId,
          title: this.before.service,
          techName: this.techName,
          _id: this.before._id,
        });
      }

      if (this.edit) {
        payload.push({
          action: this.edit.action.value,
          end: this.dateService.formatDate(this.editEndDate, datetimeFormat.yyymmddhhmm),
          start: this.dateService.formatDate(this.editStartDate, datetimeFormat.yyymmddhhmm),
          isDeleted: this.isDeleted,
          workId: this.edit.workId,
          workType: "service",
          orderId: this.edit.orderId,
          title: this.edit.service,
          techName: this.techName,
          _id: this.edit._id,
        });
      }
      if (this.after) {
        payload.push({
          action: this.after.action,
          end: this.afterEndDate ? this.dateService.formatDate(this.afterEndDate, datetimeFormat.yyymmddhhmm) : null,
          start: this.afterStartDate ? this.dateService.formatDate(this.afterStartDate, datetimeFormat.yyymmddhhmm) : null,
          workId: this.after.workId,
          orderId: this.after.orderId,
          title: this.after.service,
          techName: this.techName,
          _id: this.after._id,
        });
      }
      payload.forEach((data) => {
        let obj = {
          action: data.action,
          _id: data._id,
        };

        if (data.isDeleted) {
          obj['isDeleted'] = data.isDeleted;
        }
        if (data.start) {
          obj['start'] = data.start;
        }
        if (data.end) {
          obj['end'] = data.end;
        }

        if (data.title) {
          obj['title'] = data.title;
        }

        if (data.workId) {
          obj['workId'] = data.workId;
        }
        
        if (data.workType) {
          obj['workType'] = data.workType;
        }

        if (data.orderId) {
          obj['orderId'] = data.orderId;
        }

        if (data.techName) {
          obj['techName'] = data.techName;
        }

        finalPayload.push(obj);
      });

      this.payload = {
        payload: finalPayload,
      };
      this.updateTechAttendence(this.payload);
    }
  }

  updateTechAttendence(data) {
    this.isLoading = true;
    this.httpService.updateTechAttendence(this.techId, data).then(
      (data: any) => {
        this.isLoading = false;
        this.helperService.showToaster('success', 'Successfully updated');
        this.dataService.sendData(this.dataService.typePassData('company-appdata-updated', {}));
        this.closeAttendenceModal({isDeleted: this.isDeleted});
      },
      (err) => {
        this.isLoading = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  handleMarkdelete(e) {
    this.isDeleted = e;
  }

  closeAttendenceModal(data: any) {
    this.ref.close(data);
  }

  getServiceOverlapping(date, timeType) {
    this.serviceStartTimeOverlap = false;
    this.serviceEndTimeOverlap = false;
    let firstIndex;
    let lastIndex;
    this.techRecords.map((t, i) => {
      if (t._id === this.data.logID && t.ro === 'Clocked-in') {
        if(this.techRecords[this.data.index].workType === 'service') {
        firstIndex = this.techRecords[this.data.index];
        }
      } else if (t._id === this.data.logID && t.ro === 'Clocked-out') {
        if(this.techRecords[this.techRecords.length - (i - 1)] && this.techRecords[this.techRecords.length - (i - 1)].workType === 'service') {
        lastIndex = this.techRecords[this.techRecords.length - (i - 1) ]
        }
      }
    });

    if (timeType == 'startTime') {
      if (firstIndex && date > firstIndex.start) {
        if (this.serviceStartTimeOverlap) return;
        this.helperService.showToaster(
          'error',
          `Seems like the tech performed a service at ${this.dateService.formatDate(
            firstIndex.start,
            datetimeFormat.hhmm
          )} within this shift. The shift’s start time cannot be past that of the performed service`
        );
        this.serviceStartTimeOverlap = true;
      } else {
        this.serviceStartTimeOverlap = false;
      }
    } else if (timeType &&timeType == 'endTime') {
      if(firstIndex && date < firstIndex.end) {
        if (this.serviceEndTimeOverlap) return
        this.helperService.showToaster('error', `Seems like the tech performed a service at ${this.dateService.formatDate(firstIndex.end, datetimeFormat.hhmm)} within this shift. The shift’s end time cannot be past that of the performed service`);
        this.serviceEndTimeOverlap = true
      } else {
        this.serviceEndTimeOverlap = false
      }
    }
  }

  async handleupdateClockStartDate(type, e) {
    this.currentDateTime = await this.httpService.getServerTime();
    
    if (type === 'updateClockStartDate') {
      if (this.techRecords) {
        this.getServiceOverlapping(e, 'startTime');
      }
      this.isCurrentEditStartTime = this.updateClockStartDate !== this.updateClockInOut.start ? true : false;
      if (this.updateClockInOut.end) {
        this.updateClockStartDate = new Date(
          this.updateClockInOut.start.getFullYear(),
          this.updateClockInOut.start.getMonth(),
          this.updateClockInOut.start.getDate(),
          this.updateClockStartDate.getHours(),
          this.updateClockStartDate.getMinutes()
        );
      } else {
        this.updateClockStartDate = new Date(
          this.updateClockInOut.start.getFullYear(),
          this.updateClockInOut.start.getMonth(),
          this.updateClockInOut.start.getDate(),
          this.updateClockStartDate.getHours(),
          this.updateClockStartDate.getMinutes()
        );
      }
    } else if (type === 'updateClockEndDate') {
      if (this.techRecords) {
        this.getServiceOverlapping(e, 'endTime');
      }

      this.isCurrentEditEndTime = this.updateClockEndDate !== this.updateClockInOut.end ? true : false;
      if (this.updateClockInOut.end) {
        this.updateClockEndDate = new Date(this.updateClockInOut.start.getFullYear(), this.updateClockInOut.start.getMonth(), this.updateClockInOut.start.getDate(), e.getHours(), e.getMinutes());
      } else {
        this.updateClockEndDate = new Date(this.updateClockInOut.start.getFullYear(), this.updateClockInOut.start.getMonth(), this.updateClockInOut.start.getDate(), e.getHours(), e.getMinutes());
      }
    }

    let from = new Date(Date.parse(this.updateClockStartDate));
    let to = new Date(Date.parse(this.updateClockEndDate));

    this.isValidClockStartTime = from > to ? true : false;
    this.isValidClockEndTime = from > to ? true : false;

    if (this.updateClockStartDate && this.updateClockEndDate) {
      if (!this.isValidClockStartTime && !this.isValidClockEndTime) {
        this.getTimeOverlap('clock', this.dateService.formatDate(this.updateClockStartDate, datetimeFormat.hhmm), this.dateService.formatDate(this.updateClockEndDate, datetimeFormat.hhmm));
      }
    }
  }

  getTimeOverlap(action, startTime, endTime) {
    let query = {
      startDate: this.startDate,
      endDate: this.endDate,
      startTime: startTime ? startTime : '',
      endTime: endTime ? endTime : '',
      action: action,
      _id: this.updateClockInOut._id,
    };
    this.httpService.detectTimeOverlap(this.techId, query).then(
      (res: any) => {
        if (res) {

          if(this.workType === 'clock'){
            this.startTimeOverLap = res.startTimeOverLap || res.clockOutDetected;
            this.endTimeOverLap = res.endTimeOverLap || res.clockOutDetected;
          }else {
            this.startTimeOverLap = res.startTimeOverLap;
            this.endTimeOverLap = res.endTimeOverLap;
          }
          this.clockInDetected= false;
          if (action === 'clock' && res.clockInDetected) {
            this.clockInDetected = res.clockInDetected;
          }

          if (this.clockInDetected) {
            this.helperService.showToaster('error', 'Overlapping detected');
            return false;
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  onUpdateClockInOut() {
    if (this.startTimeOverLap || this.endTimeOverLap || this.isValidClockStartTime || this.isValidClockEndTime || (this.workType === 'clock' && this.clockInDetected)) {
      this.helperService.showToaster('error', 'Overlapping detected');
      return false;
    } else if (this.serviceStartTimeOverlap || this.serviceEndTimeOverlap) {
      return;
    } else {
      if (this.updateClockStartDate && this.updateClockEndDate) {
        let payload = [
          // edit obj
          {
            action: this.updateClockInOut.action,
            duration: this.updateClockInOut.duration,
            end: this.dateService.formatDate(this.updateClockEndDate, datetimeFormat.yyymmddhhmm),
            start: this.dateService.formatDate(this.updateClockStartDate, datetimeFormat.yyymmddhhmm),
            ro: this.updateClockInOut.ro,
            service: this.updateClockInOut.service,
            technician: this.updateClockInOut.technician,
            workType: this.updateClockInOut.workType,
            isDeleted: this.isDeleted,
            techName: this.techName,
            _id: this.updateClockInOut._id,
          },
        ];

        this.payload = {
          payload: payload,
        };
        this.updateTechAttendence(this.payload);
      }
    }
  }

  fetchInitials(name: string) {
    return this.helperService.fetchInitials(name || '');
  }
}
